import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataGridSelectionService {
  private clearSelectionSubject = new Subject<void>();

  clearSelection$ = this.clearSelectionSubject.asObservable();

  clearAllSelections(): void {
    // console.log('📢 Broadcasting clear selection to all data grids');
    this.clearSelectionSubject.next();
  }
}